import { ConstructionPeriod } from '@aviv-estimation-funnel/estimation-data-models/models/construction-period.model';

import { Filter } from '../filter';
import { ErrorType, FieldValues } from '../types';

export class ConstructionYearAndPeriodMismatchFilter implements Filter<number> {
    constructor(private constructionPeriods: ConstructionPeriod[]) {}

    async validate(fieldValue: number, otherFields: FieldValues): Promise<Array<ErrorType>> {
        // If no period is given, we can't validate anything: no error!
        if (!otherFields['constructionPeriodMin'] && !otherFields['constructionPeriodMax']) {
            return [];
        }

        // Find a ConstructionPeriod that matches the given constructionYear
        const matchConstructionPeriod: ConstructionPeriod | undefined =
            this.constructionPeriods.find(
                (constructionPeriod: ConstructionPeriod) => constructionPeriod.value === fieldValue,
            );

        // If we can't find one, it means that we should not have any period specified
        if (matchConstructionPeriod === undefined) {
            return [
                {
                    code: 'constructionYearAndPeriodMismatch',
                    expectedConstructionPeriod: {
                        min: null,
                        max: null,
                    },
                    givenConstructionYear: fieldValue,
                },
            ];
        }

        // And finally, we check that constructionPeriodMin and constructionPeriodMax are equal to
        // the ones expected from the corresponding period
        // NB: We ensure that "undefined" values are ignored to avoid comparison issues by these
        // conditions
        const constructionPeriodMin = otherFields['constructionPeriodMin']
            ? otherFields['constructionPeriodMin']
            : null;
        const constructionPeriodMax = otherFields['constructionPeriodMax']
            ? otherFields['constructionPeriodMax']
            : null;
        if (
            matchConstructionPeriod.min !== constructionPeriodMin ||
            matchConstructionPeriod.max !== constructionPeriodMax
        ) {
            return [
                {
                    code: 'constructionYearAndPeriodMismatch',
                    expectedConstructionPeriod: {
                        min: matchConstructionPeriod.min,
                        max: matchConstructionPeriod.max,
                    },
                    givenConstructionYear: fieldValue,
                },
            ];
        }

        return [];
    }
}
